import { render, staticRenderFns } from "./Marketplace.vue?vue&type=template&id=9f7aa032"
import script from "./Marketplace.vue?vue&type=script&lang=js"
export * from "./Marketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports